const api = `${process.env.PUBLIC_URL}/api`;
export const FileApi = `${api}/files.json`;
export const DefaultBoardApi = `${api}/defaultboard.json`;
export const CustomBoardApi = `${api}/customboard.json`;
export const ProductsApi = `${api}/product.json`;
export const EmailApi = `${api}/email.json`;
export const ChatMemberApi = `${api}/chatMember.json`;
export const ChatApi = `${api}/chats.json`;
export const BookmarkApi = `${api}/bookmark.json`;
export const TaskApi = `${api}/task.json`;
export const ImageLightApi = `${api}/image-light.json`;
export const BigImageApi = `${api}/image-big-light.json`;
export const MasonryApi = `${api}/masonry.json`;
export const TodoApi = `${api}/todo.json`;
export const TableDataApi = `${api}/tableData.json`;
export const GooglechartApi = `${api}/googleChartData.json`;
export const FaqApi = `${api}/Faq.json`;
export const LearningApi = `${api}/learning.json`;
export const JobSearchApi = `${api}/jobSearch.json`;
export const KnowledgebaseApi = `${api}/knowledgebaseDB.json`;